import { getBuildingLists } from '@/api/building'
// import { getBuildingLists, getRoomTreeLists } from '@/api/building'
export default {
    namespaced: true,
    state: () => ({
        treeData: [],
        roomData: []
    }),
    mutations: {
        setTreeData(state, data) {
            state.treeData = data
        },
        setRoomData(state, data) {
            state.roomData = data
        }
    },
    actions: {
        changeTreeDate(state, data) {
            return new Promise((resolve, reject) => {
                getBuildingLists()
                    .then((res) => {
                        this.commit('building/setTreeData', res)
                        // getRoomTreeLists().then(res => {
                        //     this.commit('building/setRoomData', res)
                        // })
                        resolve()
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    }
}
